module.exports = __webpack_public_path__ + "static/img/avatar-s-9.ec990ac1.png";